export const setEditMode = (editMode: boolean, isNewDraft?: any) => ({
    type: 'SET_EDIT_MODE',
    payload: {
        editMode,
        isNewDraft
    }
});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/actions/project-actions/set-edit-mode.ts